// 主持人状态
export const HOST_STATE = {
  NONE: 0,
  APPLYING: 1,
  HOST: 2,
};

// 申请上麦操作
export const APPLY_HOST_OPERATION = {
  ADD: 1,
  REMOVE: 2,
};

// 上麦操作
export const HOST_OPERATION = {
  ADD: 1,
  REMOVE: 2,
};

// 最小上麦高度
export const MIN_HOST_MODE_HEIGHT = 360;

// 最小上麦高度（有屏幕共享时）

// 获取最小上麦组件高度
export const getMinHostModeHeight = () => {
  return MIN_HOST_MODE_HEIGHT;
};

// 检查是否为最小高度
export const checkIsMinHostModeHeight = (height) => {
  return height === getMinHostModeHeight();
};

// 最小的上麦距离底部的距离s
// 用来计算最大上麦高度 => window.innerHeight - MIN_HOST_CPT_DISTANCE_TO_BOTTOM
export const MIN_HOST_CPT_DISTANCE_TO_BOTTOM = 328;

// 获取最大屏幕共享高度到底部的距离
export const getMaxHostHeightToBottom = () => {
  return MIN_HOST_CPT_DISTANCE_TO_BOTTOM;
};

// 获取最大屏幕共享高度
export const getMaxHostModeHeight = (newHeight) => {
  newHeight = newHeight || window.innerHeight;
  return newHeight - getMaxHostHeightToBottom();
};
